export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const DELETE_ORG = 'DELETE_ORG';
export const NEW_ORGANIZATION = 'NEW_ORGANIZATION';
